import selectEntityItem from "./entityItem"

export default function selectError(state, model, id) {
  const entity = selectEntityItem(state, model, id)

  return entity ? entity.error : null
}
